"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EncounterStatusSchema", {
    enumerable: true,
    get: function() {
        return EncounterStatusSchema;
    }
});
const _zod = require("zod");
const EncounterStatusSchema = _zod.z.enum([
    'draft',
    'signed'
]);
